import React from "react";
import {styled} from "@reside/ui";

import {HistoryEntry} from "../types";
import {formatDateForDisplay} from "../utils";
import {Table, Th, Td, SectionTitle} from "./table-primitives";

const ErrorCell = styled(Td)`
  color: #a10009;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StatusCell = styled(Td)<{status: string}>`
  font-weight: 500;
  color: ${({status}) => {
    switch (status) {
      case "success":
        return "#074830";
      case "failed":
        return "#a10009";
      default:
        return "#596973";
    }
  }};
`;

const HistoryRow = ({entry}: {entry: HistoryEntry}): JSX.Element => (
  <tr>
    <Td>{entry.build_number}</Td>
    <Td>{formatDateForDisplay(entry.created)}</Td>
    <Td>{entry.triggered_by}</Td>
    <StatusCell status={entry.status}>{entry.status}</StatusCell>
    <ErrorCell title={entry.error_message ?? ""}>
      {entry.error_message ?? "—"}
    </ErrorCell>
  </tr>
);

const HistoryTableHead = (): JSX.Element => (
  <thead>
    <tr>
      <Th>#</Th>
      <Th>Date</Th>
      <Th>Triggered By</Th>
      <Th>Status</Th>
      <Th>Error</Th>
    </tr>
  </thead>
);

export const HistoryTable = ({
  history,
}: {
  history: HistoryEntry[];
}): JSX.Element => {
  return (
    <>
      <SectionTitle style={{marginTop: 32}}>Processing History</SectionTitle>
      <Table>
        <HistoryTableHead />
        <tbody>
          {history.map((entry) => (
            <HistoryRow key={entry.id} entry={entry} />
          ))}
          {history.length === 0 && (
            <tr>
              <Td colSpan={5} style={{textAlign: "center", color: "#596973"}}>
                No processing history available.
              </Td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
